import {PersonNotesModal} from "./notes/PersonNotesModal";
import {NotesDisplay} from "./notes/NotesDisplay";
import Swal from "sweetalert2";
import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {handleAjaxSuccess} from "../../helpers/swalHelper";

function initPeopleDetails() {
	// Init display notes modal button
	const addNoteButton = document.querySelector('.add-note-button');

	const notesDisplay = new NotesDisplay(document.querySelector('.person-notes-display-component'));

	// noinspection DuplicatedCode
	if (addNoteButton) {
		addNoteButton.addEventListener('click', () => {
			handleNotesModalRequest(addNoteButton.dataset.route)
		})
	}

	const banButton = document.querySelector('.ban-button');

	if (banButton) {
		banButton.addEventListener('click', () => {
			ban(banButton.dataset.route);
		})
	}

	const unbanButton = document.querySelector('.unban-button');

	if (unbanButton) {
		unbanButton.addEventListener('click', () => {
			unban(unbanButton.dataset.route);
		})
	}

	// Methods

	// noinspection DuplicatedCode
	function handleNotesModalRequest(route) {
		new PersonNotesModal(route, {
			onSuccess: () => {
				// If modal made any changes, refresh notes display
				notesDisplay.update(false);
			}
		});
	}

	function ban(route) {
		Swal.fire({
			icon: "warning",
			title: 'Ban staff member?',
			inputLabel: 'Ban Reason',
			input: 'textarea',
			showCancelButton: true,
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				Axios.post(route, {
					reason: result.value,
				})
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}

	function unban(route) {
		Swal.fire({
			icon: "warning",
			title: 'Unban staff member?',
			showCancelButton: true,
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				Axios.post(route, {
					reason: result.value,
				})
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}
}

export {
	initPeopleDetails
}
